import { useEffect, useRef, useState } from 'react';
import rendererService from '../services/RendererService';
import { useTabs } from '../store/context';

export const useFocusModalAppService = (
  isVisible: boolean,
  forceFocus = false
) => {
  const [focusPrevState, setFocusPrevState] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { activeGlobalTabId } = useTabs();
  const relatedTabId = useRef<number>(activeGlobalTabId);
  const isRelatedTabActive = relatedTabId.current === activeGlobalTabId;
  const focusPrevStateRef = useRef<boolean>(focusPrevState); // Capture focusPrevState using a ref
  useEffect(() => {
    focusPrevStateRef.current = focusPrevState;
  }, [focusPrevState]);

  const focus = async () => {
    const isAppFocused = await window.dsDesktop.app.isAppViewFocus();
    setFocusPrevState(isAppFocused);
    rendererService.focusApp();
    rendererService.setHasOpenModals(true);
    setIsModalOpen(true);
  };

  const blur = () => {
    rendererService.setHasOpenModals(false);
    if (forceFocus) {
      return;
    }
    if (!focusPrevStateRef.current) {
      rendererService.blurApp();
    }
  };

  useEffect(() => {
    if (isVisible && !isModalOpen && isRelatedTabActive) {
      focus();
    }
    if (!isVisible && isModalOpen) {
      blur();
      setIsModalOpen(false);
    }
  }, [isVisible, isModalOpen, isRelatedTabActive]);

  useEffect(() => {
    return () => {
      blur();
      setIsModalOpen(false);
    };
  }, []);
};
